module.exports = __webpack_public_path__ + "static/img/CFE-School---NEW-landing-page---BLUE-Scheme.dffed78f.jpg";